import React, { useState, useEffect } from "react";
import { Card } from "@mui/material";
import { Divider, Box, Grid, Typography, Stack } from "@mui/material";
import ThumbUpOffAltIcon from "@mui/icons-material/ThumbUpOffAlt";
import ThumbDownOffAltIcon from "@mui/icons-material/ThumbDownOffAlt";
import Button from "@mui/material/Button";
import axios from "../../../utils/fvAxios";
import apiinfo from "../../../utils/base-uri.json";
import { useTranslation } from "react-i18next";
import "../../../Localization/i18n";
import { useNavigate } from "react-router-dom";
import { getOrgType } from "../../../utils/Token";



export default function VendorContractorperformance(props) {
  const { t } = useTranslation();
  const [complete, setComplete] = React.useState("");
  const params = new URLSearchParams(window.location.search);
  const PQID = params.get("pqid");

  const navigate = useNavigate();
  useEffect(() => {
    axios.get(apiinfo.vendor.GetPQContractorPerformanceEvaluation + "pqId=" + PQID
    ).then(res => {
      res.data.data && setComplete(res.data.data);
    }).catch(err => {
      console.log(err)
    })
  }, []);
  return (
    <>
      {/* <Box border={1}
        borderLeft={1}
        borderRight={1}
        borderColor="#e4e7ec" className="mt-3" sx={{ padding: "10px" }} hidden={!complete.showScorecard}>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            padding: "5px",
            "& hr": {
              mx: 0.5,
            },
          }}
        >
          <h6 className="text-muted" style={{ marginRight: "auto" }}>
            Contractor Performance Evaluation
          </h6>
          <Button variant="contained" onClick={() => props.setShow((s) => !s)} sx={{ textTransform: "capitalize", padding: "15px" }}>Completed Evaluations</Button>
        </Box>
        <Divider sx={{ backgroundColor: "#667085;", height: "2px" }} />
        <Box className="mt-3" sx={{ flexGrow: 1, paddingLeft: 1 }}>
          <Grid
            container
            spacing={{ xs: 2, md: 1 }}
            columns={{ xs: 4, sm: 8, md: 12 }}
          >
            <Grid item xs={12} sm={12} md={3}>
              <Box border={1}
                borderLeft={1}
                borderRight={1}
                borderColor="#e4e7ec" sx={{ width: "299px", padding: "10px" }} onClick={() => props.setShow((s) => !s)}>
                <Typography
                  sx={{ padding: "10px" }}
                  color="text.secondary"
                  gutterBottom
                >
                  <span sx={{ fontSize: "15px", fontWeight: 500 }}> Average Evaluation ({complete.vendorReviewAverage}) </span>
                  <Divider sx={{ marginTop: 2, marginBottom: 2, backgroundColor: "#667085;", height: "2px" }} />
                  <Button
                    style={{
                      maxWidth: "120px",
                      maxHeight: "100px",
                      minWidth: "280px",
                      minHeight: "100px",
                      backgroundColor: "#ECFDF3",
                      color: "#12B76A"
                    }}
                  >
                    <span> <ThumbUpOffAltIcon /></span> <span className="mx-1"> {complete.recommendedCount}</span>
                  </Button>
                </Typography>
                <Typography
                  sx={{ fontSize: 14, padding: "2px", marginLeft: 1 }}
                  color="text.secondary"
                  gutterBottom
                >
                  Completed by <strong>Emily Frandt</strong>
                </Typography>
              </Box>
            </Grid>

            <Grid item xs={12} sm={12} md={3}>
              <Box border={1}
                borderLeft={1}
                borderRight={1}
                borderColor="#e4e7ec" sx={{ width: "299px", padding: "10px" }} onClick={() => props.setShow((s) => !s)}>
                <Typography
                  sx={{ padding: "10px" }}
                  color="text.secondary"
                  gutterBottom
                >
                  <span sx={{ fontSize: "15px", fontWeight: 500 }}> Average Project Evaluation ({complete.vendorProjectReviewAverage}) </span>
                  <Divider sx={{ marginTop: 2, marginBottom: 2, backgroundColor: "#667085;", height: "2px" }} />
                  <Button
                    style={{
                      maxWidth: "120px",
                      maxHeight: "100px",
                      minWidth: "280px",
                      minHeight: "100px",
                      backgroundColor: "#FDECEC",
                      color: "#EE3F3F"
                    }}
                  >
                    <span><ThumbDownOffAltIcon sx={{ color: "#EE3F3F" }} /> </span><span className="mx-1"> {complete.notRecommendedCount}</span>
                  </Button>
                </Typography>

                <Typography

                  sx={{ fontSize: 14, padding: "2px" }}
                  color="text.secondary"
                  gutterBottom
                >
                  <span className="mt-2">Completed by <strong>Emily Frandt</strong></span>
                </Typography>
              </Box>
            </Grid>
          </Grid>
        </Box>
        <br />
      </Box> */}
      <Box border={1}
        borderLeft={1}
        borderRight={1}
        borderColor="#e4e7ec" className="mt-3" sx={{ padding: "20px" }} hidden={!complete.showScorecard}>
        <Box
          className="Large"
          sx={{
            display: "flex",
            alignItems: "center",
            padding: "5px",
            "& hr": {
              mx: 0.5,
            },
          }}
        >
          <span className="text-muted" style={{ marginRight: "auto", fontWeight: "bolder", fontSize: "larger" }}>
            {t('VendorDetails.label21')}
          </span>

        </Box>
        <Box
          className="small"
        >
          <Stack>
            <h6 className="text-muted" >
              {t('VendorDetails.label21')}
            </h6>

            <Button variant="contained" onClick={() => props.setShow((s) => !s)} sx={{ textTransform: "capitalize", padding: "15px" }}>{t('VendorDetails.label22')}</Button>
          </Stack>
        </Box>


        <Box sx={{ flexGrow: 1, marginTop: "10px" }}>
          <Grid container spacing={{ xs: 2, md: 3 }}>
            <Grid item xs={12} md={3}>
              <Box border={1}
                borderLeft={1}
                borderRight={1}
                borderColor="#e4e7ec" sx={{ cursor: "pointer" }} onClick={() => props.setShow((s) => !s)}>
                <Stack spacing={1}>
                  <Box sx={{
                    width: "auto", height: "80px", backgroundColor: '#ECFDF3', alignItems: "center",
                    display: "flex",
                    justifyContent: "center"
                  }}> <span style={{ margin: "auto", justifyContent: "center", color: "#12B76A" }}><ThumbUpOffAltIcon /> {complete.recommendedCount} </span></Box>
                  <Box sx={{
                    width: "auto", height: "80px", backgroundColor: '#FDECEC', alignItems: "center",
                    display: "flex",
                    justifyContent: "center"
                  }}> <span style={{ margin: "auto", justifyContent: "center", color: "#EE3F3F" }}><ThumbDownOffAltIcon /> {complete.notRecommendedCount} </span></Box>

                </Stack>
              </Box>
            </Grid>
            <Grid item xs={12} md={3}>
              <Box border={1}
                borderLeft={1}
                borderRight={1}
                borderColor="#e4e7ec" sx={{ height: "168px", padding: "10px" }}>
                <Typography
                  className="textsize"

                  color="text.secondary"
                  gutterBottom
                >
                  <span className="textsize" style={{ marginLeft: "5px" }}>{t('VendorDetails.label23')}  ({complete.vendorReviewAverage}) </span>
                  <hr />
                  <span className="textsize" style={{ marginLeft: "5px" }}> {t('VendorDetails.label24')} ({complete.vendorProjectReviewAverage}) </span>
                  <hr />
                  <span className="textsize mt-2" style={{ marginLeft: "5px" }}>{t('VendorDetails.label25')} <strong>{complete?.lastEvaluatedBy}</strong></span>


                </Typography>
              </Box>
            </Grid>

            <Grid item xs={12} md={3} >
              <Stack spacing={1}>

                <Button variant="contained" hidden={getOrgType() == "Admin"} onClick={() => props.RatingTypeChange((p) => !p, 1)} sx={{ textTransform: "capitalize", padding: "15px", }}> {t('VendorDetails.label33')}</Button>
                <Button variant="contained" hidden={getOrgType() == "Admin"} onClick={() => props.RatingTypeChange((p) => !p, 2)} disabled={complete?.isEvaluationExpired == true} sx={{ textTransform: "capitalize", padding: "15px" }}> {t('VendorDetails.label34')}</Button>

                <Stack spacing={1} style={{ marginTop: "45px" }}>
                  <Button variant="contained" onClick={() => props.setShow((s) => !s)} sx={{ textTransform: "capitalize", padding: "15px" }}>{t('VendorDetails.label22')}</Button>
                </Stack>
              </Stack>
            </Grid>

          </Grid>
        </Box>
      </Box>

    </>
  )
}